import { Subscription } from 'rxjs';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute,NavigationEnd } from '@angular/router';
import { Credentials } from '../../../models/credentials.interface';
import { UserService } from '../../../services/user.service';
import { UtilityService } from '../../../services/Acc_Utility.service';
import { Global } from '../../global';
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit, OnDestroy {
  ArrLabels: any;
  labels: any = {};
  private subscription: Subscription;
  brandNew: boolean;
  errors: string;
  isRequesting: boolean;
  submitted: boolean = false;
  credentials: Credentials = { email: '', password: '' };
  constructor(
    private userService: UserService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private UtilityService: UtilityService,
    private global: Global)
    { this.router.routeReuseStrategy.shouldReuseRoute = function(){
      return false;
  };
  
  this.router.events.subscribe((evt) => {
      if (evt instanceof NavigationEnd) {
          this.router.navigated = false;
          window.scrollTo(0, 0);
      }
  });}
  ngOnInit() {    
    this.getLabels();
    // subscribe to router event
    this.subscription = this.activatedRoute.queryParams.subscribe(
      (param: any) => {
        this.brandNew = param['brandNew'];
        this.credentials.email = param['email'];
      });
  }

  ngOnDestroy() {
    // prevent memory leak by unsubscribing
    this.subscription.unsubscribe();
  }

  login({ value, valid }: { value: Credentials, valid: boolean }) {
    this.submitted = true;
    this.isRequesting = true;
    this.errors = '';
    if (valid) {
      this.userService.login(value.email, value.password)
        .finally(() => this.isRequesting = false)
        .subscribe(
        result => {
          if (result) {
            //this.router.navigate(['/']);
            this.router.navigate(['/'])
              .then(() => {
                window.location.reload();
            });
          }
        },
        error => this.errors = error);
    }
  }

  getLabels(){
    this.UtilityService.getLabels('login',this.global.lang)
      .subscribe(response => {
          if(response){
              this.ArrLabels = response;
              this.setLabels();
          }
      },
      error => console.log(error))
    }
  
  
  setLabels(){
    //title
    this.labels['login-title'] = this.ArrLabels.find( (o:any) => o.key === 'login-title').value;
  
    // labels
    this.labels['UserID'] = this.ArrLabels.find( (o:any) => o.key === 'UserID').value;
    this.labels['Password'] = this.ArrLabels.find( (o:any) => o.key === 'Password').value;
    this.labels['Login'] = this.ArrLabels.find( (o:any) => o.key === 'Login').value;
  
    // Alerts
    this.labels['UserIDRequired'] = this.ArrLabels.find( (o:any) => o.key === 'UserIDRequired').value;
    
  }
  
  
}



// WEBPACK FOOTER //
// ./src/app/components/account/login/login.component.ts